{
    "ChartprovideroptionsHighcharts": "Gráficos altos",
    "ChartprovideroptionsAmcharts": "Gráficos AM",
    "NAME": "ChartProviderOptions"
}